import { ScheduledPriorityListStream } from "../../../../api/priorityListApi";
import { OverlapPair, PriorityStreamPreview } from "./types";

const isOverlapping = (
    a: { startTime: string; endTime: string },
    b: { startTime: string; endTime: string }
) => new Date(a.startTime) < new Date(b.endTime) && new Date(b.startTime) < new Date(a.endTime);

export const findNewVsNewOverlaps = (previews: PriorityStreamPreview[]): OverlapPair[] => {
    const newStreams = previews.map(s => ({ name: s.programName, startTime: s.startTime, endTime: s.endTime }));
    const overlaps: OverlapPair[] = [];
    for (let i = 0; i < newStreams.length; i++) {
        for (let j = i + 1; j < newStreams.length; j++) {
            if (isOverlapping(newStreams[i], newStreams[j])) {
                overlaps.push({
                    streamA: { name: newStreams[i].name, startTime: newStreams[i].startTime },
                    streamB: { name: newStreams[j].name, startTime: newStreams[j].startTime },
                });
            }
        }
    }
    return overlaps;
};

export const findNewVsExistingOverlaps = (
    previews: PriorityStreamPreview[],
    existing: ScheduledPriorityListStream[]
): OverlapPair[] => {
    const overlaps: OverlapPair[] = [];
    for (const ns of previews) {
        for (const es of existing) {
            if (isOverlapping({ startTime: ns.startTime, endTime: ns.endTime }, es)) {
                overlaps.push({
                    streamA: { name: ns.programName, startTime: ns.startTime },
                    streamB: { name: es.name, startTime: es.startTime },
                });
            }
        }
    }
    return overlaps;
};

const convertTimeToMinutes = (time: string) => {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return hours * 60 + minutes + (seconds ? seconds / 60 : 0);
};

export const calculateEventTime = (startTime: string, endTime: string, intervalMinutes: number) => {
    const startMinutes = convertTimeToMinutes(startTime);
    const endMinutes = convertTimeToMinutes(endTime);
    const startOffset = startMinutes % intervalMinutes;
    const offsetPercentage = (startOffset / intervalMinutes * 100).toFixed(2);
    const startInterval = Math.floor(startMinutes / intervalMinutes) + 1;
    const eventDurationPercentage = ((endMinutes - startMinutes) / intervalMinutes * 100).toFixed(2);
    return { startInterval, offsetPercentage, eventDurationPercentage };
};

export const extractTimeFromDateTime = (dateTime: string): string => {
    const date = new Date(dateTime);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
};
